import { RefObject, useRef } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import GymChainProgramAccessCategoryInfoTemplate from '../../templates/GymChainProgramAccessCategoryInfo/GymChainProgramAccessCategoryInfo';

interface chainIdType {
  chainId: string;
}

const MainColumn = (props: { alertRef: RefObject<AlertType>; backPath: string }) => {
  const { accessCategoryId, chainId } = useParams<{ accessCategoryId: string; chainId: string }>();
  const { t } = useTranslation();
  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymChainProgramAccessCategoryInfoTemplate
        type="new"
        alertRef={props.alertRef}
        alertMessage={t('ADD_NEW_GYM_ACCESS_CATEGORY.ALERT_MESSAGE_SUCCESS')}
        backPath={props.backPath}
      />
    </Card>
  );
};

const AddNewGymChainProgramAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const location = useLocation<{ from?: string; gymId?: number }>();
  const { chainId, gymId } = useParams<chainIdType & { gymId?: string }>();
  const locationGymId = location.state?.gymId || (gymId ? +gymId : undefined);
  const backPath =
    location.state?.from === 'chain' || !locationGymId
      ? `/gymChains/${chainId}/gymChainAccessCategories`
      : `/gymChains/${chainId}/gyms/${locationGymId}/gymAccessCategories`;
  const backState = { accessCategoryTab: 'bookings' };

  return (
    <TwoColTemplate
      title={t('ADD_NEW_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} backPath={backPath} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(backPath, backState)}
    />
  );
};

export default AddNewGymChainProgramAccessCategoryPage;
